import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import { DnDList } from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

export const ChangePositionList: React.FC = () => {
	const portionHeadingClasses = classNames(style.portion, style.heading);
	const posNameHeadingClasses = classNames(style.posName, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const externalIdHeadingClasses = classNames(style.externalId, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const isDisabledHeadingClasses = classNames(style.isDisabled, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={portionHeadingClasses}
					translationNameSpace="listing"
					translationKey="portionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={posNameHeadingClasses}
					translationNameSpace="listing"
					translationKey="posNameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={externalIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="externalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isDisabledHeadingClasses}
					translationNameSpace="listing"
					translationKey="disabledLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};
